// @flow
import { getCookieVal, setCookie } from '../util/cookies'
import * as actionTypes from '../constants/action_types'
import * as ids from '../constants/ids'
import type { PropsType } from '../components/settings'

export type SettingsBarType = {
    visible: boolean,
    animationMode: boolean,
    historyCount: number,
    mapLegendPlacement: 'none' | 'upperLeft' | 'upperRight' | 'lowerRight' | 'lowerLeft',
    opacity: number,
    popupOpacity: number,
}

export type SettingsBarActionType = {
    active: boolean,
    type: string,
    newSettings: PropsType
}

const initialState = {
    visible: true,
    animationMode: getCookieVal('animationMode') === 'true',
    historyCount: parseInt(getCookieVal('historyCount', 10), 10),
    mapLegendPlacement: getCookieVal('mapLegendPlacement', 'lowerRight'),
    opacity: parseFloat(getCookieVal('opacity', 0.5)),
    popupOpacity: parseFloat(getCookieVal('popupOpacity', 0.7)),
}

export default function SettingsBar(state: SettingsBarType = initialState, action: SettingsBarActionType) {
    let newState = state

    if (action.type === actionTypes.CLICK_CONTEXT_BAR_ITEM) {
        if (action.id === ids.SETTINGS) {
            // Toggle the control bar if clicking an already-active framework button.
            // Otherwise, always show the control bar.
            newState = (action.active
                ? { ...state, visible: !state.visible }
                : { ...state, visible: true })
        }
    } else if (action.type === actionTypes.UPDATE_SETTINGS) {
        newState = {
            ...state,
            ...action.newSettings,
        }
        setCookie('animationMode', newState.animationMode ? 'true' : 'false')
        setCookie('historyCount', newState.historyCount)
        setCookie('mapLegendPlacement', newState.mapLegendPlacement)
        setCookie('popupOpacity', newState.popupOpacity)
        setCookie('opacity', newState.opacity)
    }

    return newState
}
